import { getPersonAttributes } from './services/person-attributes.service';

/**
 * @param {Record<string, unknown>|null|undefined} person
 * @returns {string}
 */
export function getPersonDisplayName(person) {
  if (!person) {
    return '—';
  }
  const first = person.displayFirstName || person.firstName || '';
  const last = person.displayLastName || person.lastName || '';
  const combined = `${first} ${last}`.trim();
  return combined || person.username || '—';
}

/** Merge loading placeholders for the given person ids into the attributes map. */
export function withLoadingPlaceholders(prev, personIds) {
  const next = { ...prev };
  personIds.forEach((id) => {
    next[id] = { status: 'loading', items: [] };
  });
  return next;
}

/**
 * @returns {Promise<{ id: number, items: Array, ok: boolean }>}
 */
export async function fetchAttributesForPerson(personId) {
  try {
    const items = await getPersonAttributes(personId);
    return { id: personId, items: Array.isArray(items) ? items : [], ok: true };
  } catch {
    return { id: personId, items: [], ok: false };
  }
}

/** Apply prefetch rows from {@link fetchAttributesForPerson} into the attributes map. */
export function mergeAttributePrefetchRows(prev, rows) {
  const next = { ...prev };
  rows.forEach(({ id, items, ok }) => {
    next[id] = { status: ok ? 'ok' : 'error', items };
  });
  return next;
}
